"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* exported SecureMessage MessagingIndexPage MessagingViewPage */
var SecureMessage = function () {
  function SecureMessage(id, patient_id, from_provider, from_name, subject, text, date_sent, date_read, date_replied, message_type, active_invitation) {
    _classCallCheck(this, SecureMessage);

    this.id = id;
    this.patient_id = patient_id;
    this.from_provider = from_provider;
    this.from_name = from_name;
    this.subject = subject;
    this.text = text;
    this.date_sent = new Date(date_sent);
    this.date_read = null;
    if (date_read) {
      this.date_read = new Date(date_read);
    }
    this.date_replied = null;
    if (date_replied) {
      this.date_replied = new Date(date_replied);
    }
    this.sync_status = "pending";

    this.message_type = message_type;
    this.active_invitation = active_invitation;
  }

  _createClass(SecureMessage, [{
    key: "makeFromName",
    value: function makeFromName() {

      var fromText = $t("messaging.from") + " ";
      if (this.from_provider) {
        fromText += this.from_name;
      } else {
        fromText += $t("messaging.me");
      }

      return fromText;
    }
  }, {
    key: "toHash",
    value: function toHash() {

      var fromText = this.makeFromName();
      var subject = this.subject;

      if ($.trim(subject) == "") {
        subject = this.text;
      }

      return {
        "id": this.id,
        "patient_id": this.patient_id,
        "from_provider": this.from_provider,
        "from_name": fromText,
        "subject": subject,
        "text": this.text,
        "date_sent": this.fromNow(),
        "date_read": this.date_read,
        "full_date": this.fullDateTime()

      };
    }
  }, {
    key: "encrypt",
    value: function (_encrypt) {
      function encrypt() {
        return _encrypt.apply(this, arguments);
      }

      encrypt.toString = function () {
        return _encrypt.toString();
      };

      return encrypt;
    }(function () {
      var encypted_message = {
        "id": this.id,
        "patient_id": this.patient_id,
        "subject": this.subject,
        "text": this.text,
        "date_sent": this.date_sent
      };

      return encrypt(JSON.stringify(encypted_message));
    })
  }, {
    key: "markRead",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(date_read) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.date_read = date_read;
                _context.next = 3;
                return modifyMessageAsync(JSON.stringify({ id: this.id, date_read: this.date_read }));

              case 3:
                result = _context.sent;

                Profile.unread_message_count--;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function markRead(_x) {
        return _ref.apply(this, arguments);
      }

      return markRead;
    }()
  }, {
    key: "fromNow",
    value: function fromNow() {
      return prettyDate(this.date_sent);
    }
  }, {
    key: "fullDateTime",
    value: function fullDateTime() {
      return kanayo.date.formatDateTime(this.date_sent);
    }
  }, {
    key: "isActiveVCInvite",
    value: function isActiveVCInvite() {
      return this.message_type == 1 && this.active_invitation && !this.hasInviteExpired();
    }
  }, {
    key: "hasInviteExpired",
    value: function hasInviteExpired() {
      return moment(this.date_sent).toDate() < moment().subtract(10, 'minute').toDate();
    }
  }], [{
    key: "compare",
    value: function compare(a, b) {
      if (a.date_sent < b.date_sent) {
        return 1;
      }
      if (a.date_sent > b.date_sent) {
        return -1;
      }
      return 0;
    }
  }]);

  return SecureMessage;
}();

var SecureMessageStore = function () {
  //Warning: this store only contains a page of messages at a time.

  function SecureMessageStore(endDate, totalMessagesOnServer) {
    _classCallCheck(this, SecureMessageStore);

    var self = this;
    this.endDate = endDate.toISOString();
    this.totalMessagesOnServer = totalMessagesOnServer;
  }

  _createClass(SecureMessageStore, [{
    key: "init",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var messagesAndTotalCount;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getMessagesList(this.endDate, this.count);

              case 2:
                messagesAndTotalCount = _context2.sent;

                this.messages = messagesAndTotalCount.messages;
                this.totalMessagesOnServer = messagesAndTotalCount.total_message_count;
                this.hasTreatmentTeam = messagesAndTotalCount.has_treatment_team;
                return _context2.abrupt("return", this);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _ref2.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getMessagesList",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(endDate, count) {
        var result_json, messages_json, total_message_count, has_treatment_team, messages, index, m_json, from_provider, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return loadMessagesAsync({ endDate: endDate, count: count });

              case 2:
                result_json = _context3.sent;
                messages_json = JSON.parse(result_json.messages);
                total_message_count = result_json.total_message_count;
                has_treatment_team = result_json.has_treatment_team == null || result_json.has_treatment_team;
                messages = [];

                for (index in messages_json) {
                  m_json = messages_json[index];
                  from_provider = !(m_json.from_type == "Patient");
                  message = new SecureMessage(m_json['id'], Auth.patientId(), from_provider, m_json['from']['messageable_full_name'], m_json['subject'], m_json['text'], m_json['date_sent'], m_json['date_read'], m_json['date_replied'], m_json['message_type'], m_json['active_invitation']);

                  messages.push(message);
                }

                messages.sort(SecureMessage.compare);

                return _context3.abrupt("return", { messages: messages, total_message_count: total_message_count, has_treatment_team: has_treatment_team });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMessagesList(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return getMessagesList;
    }()
  }]);

  return SecureMessageStore;
}();

var MessagingIndexPage = function () {
  function MessagingIndexPage() {
    _classCallCheck(this, MessagingIndexPage);
  }

  _createClass(MessagingIndexPage, null, [{
    key: "open",
    value: function open() {
      startLoadingSpinner();
      openPage("messaging");
      var perPage = mymobileConfig.secure_messaging.per_page;
      var messageStore = new SecureMessageStore(new Date(), perPage);
      MessagingIndexPage.clear($t('messaging.loading'));
      messageStore.init().then(function (results) {
        MessagingIndexPage.clear("");
        MessagingIndexPage.displayMessages(messageStore.messages, messageStore.totalMessagesOnServer, messageStore.hasTreatmentTeam);
        stopLoadingSpinner();
      }, function (error) {
        console.error(error);

        var mess = $t("messaging.error_loading");
        if (error.statusText == "Unauthorized") {
          mess = $t("messaging.login_to_view_messages");
        }

        MessagingIndexPage.clear(mess);
        stopLoadingSpinner();
      });
    }
  }, {
    key: "clear",
    value: function clear(mess) {
      $('#secure-messages-list .message').remove();
      $('#secure-messages-list').removeData('total-message-count');
      $('#secure-messages-list .no-messages').text(mess).show();
      $('#load-more-messages-div').hide();
    }
  }, {
    key: "displayMessages",
    value: function displayMessages(messages, messageCount, allowSend) {

      if (!allowSend) {
        $('#new-message').hide();
        $('#reply-message').hide();
      } else {
        $('#new-message').show();
        $('#reply-message').show();
      }

      $('#secure-messages-list .message').remove();

      $('#secure-messages-list').data('total-message-count', messageCount);

      if (messages.length == 0) {
        $('#secure-messages-list .no-messages').text($t("messaging.no_messages")).show();
        return;
      } else {
        $('#secure-messages-list .no-messages').hide();
      }

      if (messages.length > 0 && messages.length < messageCount) {
        $('#load-more-messages-div').show();
        $('#load-more-messages').data('last-message-date', messages[messages.length - 1].date_sent);
      } else {
        $('#load-more-messages-div').hide();
      }

      var messagesListMarkup = MessagingIndexPage.getMessageMarkup(messages);
      $(messagesListMarkup[0]).addClass('ui-first-child');
      $('#secure-messages-list').append($(messagesListMarkup));
    }
  }, {
    key: "displayMoreMessages",
    value: function displayMoreMessages(messages, messageCount) {
      var messagesListMarkup = MessagingIndexPage.getMessageMarkup(messages);
      var total_message_count = $('#secure-messages-list').data('total-message-count');

      //Reset last child in list
      $('#secure-messages-list .ui-last-child').removeClass('ui-last-child');
      $('#secure-messages-list').append($(messagesListMarkup));

      if (messages.length > 0 && messageCount > $('#secure-messages-list li.message').length) {
        $('#load-more-messages-div').show();
        $('#load-more-messages').data('last-message-date', messages[messages.length - 1].date_sent);
      }
    }
  }, {
    key: "loadMoreMessages",
    value: function loadMoreMessages(element) {
      var last_message_date = $(element).data("last-message-date");
      var per_page = mymobileConfig.secure_messaging.per_page;
      var total_message_count = $('#secure-messages-list').data('total-message-count');

      //Subtract 1 second from last date
      last_message_date = new Date(last_message_date.getTime() - 1000);

      var messageStore = new SecureMessageStore(last_message_date, per_page);
      messageStore.init().then(function (results) {
        var sms = results;
        MessagingIndexPage.displayMoreMessages(sms.messages, sms.totalMessagesOnServer);
        if (total_message_count > $('#secure-messages-list li.message').length) {
          $('#load-more-messages').data('last-message-date', sms.messages[sms.messages.length - 1].date_sent);
          $("#load-more-messages-div").show();
        } else {
          $("#load-more-messages-div").hide();
        }
      });
    }
  }, {
    key: "getMessageMarkup",
    value: function getMessageMarkup(messages) {
      var messageMarkupArray = [];
      for (var index in messages) {
        var message = messages[index];
        var messageHTML = ich.t_secureMessageItem(message.toHash());

        $(messageHTML).data("message", message);
        if (index == messages.length - 1) {
          $(messageHTML).addClass('ui-last-child');
        }

        if (message.from_provider && !message.date_read) {
          $(messageHTML, ".message-text").css("font-weight", "bold");
        }

        messageMarkupArray.push(messageHTML[0]);
      }
      return messageMarkupArray;
    }
  }, {
    key: "markMessageRead",
    value: function markMessageRead(message_id) {
      $('#secure-message-item-' + message_id).css('font-weight', 'normal');
    }
  }]);

  return MessagingIndexPage;
}();

var MessagingViewPage = function () {
  function MessagingViewPage() {
    _classCallCheck(this, MessagingViewPage);
  }

  _createClass(MessagingViewPage, null, [{
    key: "open",
    value: function open(element) {
      openPage("messaging-message");
      MessagingViewPage.clear();

      var message = element.data("message");
      MessagingViewPage.display(message);

      if (message.from_provider && !message.date_read) {
        message.markRead(new Date());
        MessagingIndexPage.markMessageRead(message.id);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      $("#messaging-message .message-info .message-title").text(" ");
      $("#messaging-message .message-info .message-from").text(" ");
      $("#messaging-message .message-info .message-sent").text("");
      $("#messaging-message .message-body > textarea").val("");

      $("#messaging-message #reply-message-row").hide();
      $('#messaging-message #reply-message').unbind('click');

      $("#messaging-message #open-video-message").hide();
    }
  }, {
    key: "display",
    value: function display(message) {
      $("#messaging-message .message-info .message-title").text(message.subject);
      $("#messaging-message .message-info .message-from").text(message.makeFromName());
      $("#messaging-message .message-info .message-sent").text(message.fullDateTime());
      $("#messaging-message .message-body > textarea").val(message.text);

      if (message.from_provider) {
        if (message.isActiveVCInvite()) {
          $("#messaging-message #open-video-message").show();
        }
        $("#messaging-message #reply-message-row").show();
        $("#messaging-message #reply-message").click(function () {
          MessagingNewPage.open(message);
        });
      }
    }
  }]);

  return MessagingViewPage;
}();

var MessagingNewPage = function () {
  function MessagingNewPage() {
    _classCallCheck(this, MessagingNewPage);
  }

  _createClass(MessagingNewPage, null, [{
    key: "open",
    value: function open(message) {
      openPage("messaging-new-message");
      MessagingNewPage.clear();

      //Create message subject options from translation file
      if ($('select#message-subject option').length == 0) {
        var subjects = $t("messaging.message_subjects", { returnObjectTrees: true });
        for (var index in subjects) {
          var subject_text = subjects[index];
          $('select#message-subject').append($("<option></option>").attr("value", subject_text).text(subject_text));
        }
      }

      if (message) {
        var subjectWithoutShorthand = message.subject.replace(/^re: /, '');
        $("#message-subject-select-div").hide();
        $("#message-subject-input-text-div").hide();
        $("#message-subject-static-text").text(subjectWithoutShorthand).show();
        $("#send-message").click(function () {
          MessagingNewPage.sendMessage(subjectWithoutShorthand);
        });
      } else {
        $("#send-message").click(function () {
          MessagingNewPage.sendMessage(null);
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      $("#send-message").unbind('click');
      $('select#message-subject').val('').change();
      if (mymobileConfig.secure_messaging.text_input_for_message_subject) {
        $("#message-subject-select-div").hide();
        $("#message-subject-input-text-div").show();
      } else {
        $("#message-subject-select-div").show();
        $("message-subject-input-text-div").hide();
      }
      $("#message-subject-static-text").text("").hide();

      $("#messaging-new-message .message-info textarea[name='message-subject-text']").val("");

      $("#messaging-new-message .message-info .message-sent").text("");
      $("#messaging-new-message .message-body > textarea").val("");
      $("#messaging-new-message .message-body > textarea").css("font-family", "Source Sans Pro, sans-serif");
      $("#message-empty-error").hide();
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(subject) {

      var text = $("#messaging-new-message .message-body > textarea").val();

      if ($.trim(text) == "") {
        $("#message-empty-error").show();
        return;
      }

      $("#message-empty-error").hide();

      startLoadingSpinner();
      var date_sent = new Date();

      if (subject == null) {
        if (mymobileConfig.secure_messaging.text_input_for_message_subject) {
          subject = $("#messaging-new-message .message-info textarea[name='message-subject-text']").val();
        } else {
          subject = $("#messaging-new-message .message-info select[name='message-subject'] option:selected").text();
        }
      }

      var message = new SecureMessage(null, parseInt(Profile.json.patientId), false, null, subject, text, date_sent, null, 0, false);

      Store.saveMessage(message.encrypt());

      MessagingNewPage.clear();
      MainPage.syncNextLoad = true;
      stopLoadingSpinner();
      openPage('main');
    }
  }]);

  return MessagingNewPage;
}();